import React, { Component } from 'react';
import ReactModal from 'react-modal';
import { actionHomeAudioComplaint } from '../../actions/installationAction';
import { HOME_AUDIO_COMPLAINT_ACTIONS } from './homeAudioUtils';

// The three service-partner actions on a Home Audio complaint, rendered inside the shared
// complaint Actions dropdown. Move errors surface through alert(), like every other item there.
class HomeAudioComplaintActions extends Component {
    state = { partsOpen: false, parts: '', submitting: false, error: null };

    submit = async (action, comments) => {
        this.setState({ submitting: true, error: null });
        const result = await actionHomeAudioComplaint({ complaint_id: this.props.complaintId, action, comments });
        if (!result.success) {
            this.setState({ submitting: false, error: result.error });
            if (action !== 'parts_used') {
                alert(result.error);
            }
            return;
        }
        this.setState({ submitting: false, partsOpen: false, parts: '' });
        if (this.props.onDone) {
            this.props.onDone();
        }
    };

    handleItemClick = (e, action) => {
        e.preventDefault();
        if (action === 'parts_used') {
            this.setState({ partsOpen: true, parts: '', error: null });
            return;
        }
        this.submit(action, '');
    };

    render() {
        const { partsOpen, parts, submitting, error } = this.state;
        return (
            <>
                {HOME_AUDIO_COMPLAINT_ACTIONS.map((action) => (
                    <a className="dropdown-item" href="#" key={action.key} onClick={(e) => this.handleItemClick(e, action.key)}>
                        <i className={action.icon} /> {action.label}
                    </a>
                ))}

                <ReactModal isOpen={partsOpen} onRequestClose={() => this.setState({ partsOpen: false })} ariaHideApp={false}>
                    <div className="ha-modal">
                        <h5 id="rModal_head">Parts used</h5>
                        <textarea
                            className="ha-textarea"
                            rows="3"
                            autoFocus
                            placeholder="Parts replaced or used at the visit"
                            value={parts}
                            onChange={(e) => this.setState({ parts: e.target.value, error: null })}
                        />
                        {error && <div className="ha-error ha-error-inline">{error}</div>}
                        <div className="ha-modal-actions">
                            <button className="ha-btn ha-btn-ghost" disabled={submitting} onClick={() => this.setState({ partsOpen: false })}>
                                Cancel
                            </button>
                            <button className="ha-btn ha-btn-primary" disabled={submitting} onClick={() => this.submit('parts_used', parts)}>
                                {submitting ? 'Saving…' : 'Record Parts'}
                            </button>
                        </div>
                    </div>
                </ReactModal>
            </>
        );
    }
}

export default HomeAudioComplaintActions;
